import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isObjectHasValues',
  standalone: true,
})
export class IsObjectHasValuesPipe implements PipeTransform {
  transform(value: Record<string, unknown> | null | undefined): boolean {
    if (!value || typeof value !== 'object') {
      return false;
    }
    return Object.values(value).some((v) => !!v);
  }
}
